import { useLocation } from 'react-router'

import { Skeleton, SkeletonPage } from '@/components/ui/skeleton'
import { ProductPageSkeleton } from './ProductPageSkeleton'
import { ShellRail, useProductShell } from './ProductShell'

/** The rail's rows while the product that lists them is still loading. */
export function RailRowsSkeleton() {
  return (
    <div aria-hidden="true" className="flex flex-col gap-3 p-4">
      {Array.from({ length: 7 }).map((_, index) => (
        <Skeleton key={index} className="h-5 w-full" />
      ))}
    </div>
  )
}

/**
 * A product page still loading. In the shared shell it fills the shell's rail with placeholder rows and
 * shows the page it is headed for; on its own it draws a rail of its own beside the page.
 */
export function ProductLoadingPage({ path }: { path?: string }) {
  const shell = useProductShell()
  const { pathname } = useLocation()
  if (!shell) return <SkeletonPage rail />
  return (
    <>
      <ShellRail>
        <RailRowsSkeleton />
      </ShellRail>
      <ProductPageSkeleton path={path ?? pathname} />
    </>
  )
}
